module.exports = __webpack_public_path__ + "static/media/email-icon.1e84ffdf.svg";